// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('orderHeadCreateProject', {
//         templateUrl: 'views/components/views/orderHeadCreateProject/orderHeadCreateProject.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'orderHeadCreateProjectService', 'projectService', function ($stateParams, stateService, translateService, modalService, orderHeadCreateProjectService, projectService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderInternalNo = $stateParams.order_internal_no;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListProjectManagers: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//             	vm.model.edit = (await orderHeadCreateProjectService.getEdit({ order_internal_no: orderInternalNo }))[0];
//             }

//             async function loadProjectManagers() {
//                 vm.model.selectListProjectManagers = await projectService.listProjectManagers();
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 orderHeadCreateProjectService.saveObj(vm.model.edit).then((response) => {
//                     if (response[0] && response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//             	loadEdit();
//                 loadProjectManagers();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
